<div class="help-widget" [class.open]="isOpen()">
  @if (isOpen()) {
    <section
      class="help-panel"
      role="dialog"
      aria-modal="false"
      aria-label="Help and FAQ">
      <header class="help-header">
        <div>
          <h3>{{ panelTitle }}</h3>
          <p>{{ panelSubtitle }}</p>
        </div>
        <div class="header-actions">
          @if (currentSection() !== 'menu') {
            <button
              type="button"
              class="icon-button"
              (click)="goToMenu()"
              aria-label="Back to help menu">
              Back
            </button>
          }
          <button
            type="button"
            class="icon-button"
            (click)="closePanel()"
            aria-label="Close help assistant">
            X
          </button>
        </div>
      </header>

      <div class="help-content">
        @if (currentSection() === 'menu') {
          <button type="button" class="menu-card" (click)="reportBug()" [disabled]="isOpeningBugReport()">
            <span class="menu-title">Report Bug</span>
            <span class="menu-caption">
              @if (isOpeningBugReport()) {
                Opening bug report form...
              } @else {
                Opens Microsoft Forms in a new tab.
              }
            </span>
          </button>

          @if (bugReportError()) {
            <p class="inline-error">{{ bugReportError() }}</p>
          }

          <button type="button" class="menu-card" (click)="openInitialMapping()">
            <span class="menu-title">Mapping (Initial)</span>
            <span class="menu-caption">Infographic and flow visual guides</span>
          </button>

          <button type="button" class="menu-card" (click)="openRetrainMapping()">
            <span class="menu-title">Mapping (Retrain)</span>
            <span class="menu-caption">Infographic and flow visual guides</span>
          </button>
        } @else if (currentSection() === 'mappingInitial') {
          @for (image of initialMappingImages; track image.id) {
            <button type="button" class="image-card" (click)="showImage(image)">
              <span class="menu-title">{{ image.title }}</span>
              <span class="menu-caption">{{ image.caption }}</span>
            </button>
          }
        } @else {
          @for (image of retrainMappingImages; track image.id) {
            <button type="button" class="image-card" (click)="showImage(image)">
              <span class="menu-title">{{ image.title }}</span>
              <span class="menu-caption">{{ image.caption }}</span>
            </button>
          }
        }
      </div>
    </section>
  }

  @if (activeImage(); as image) {
    <button
      type="button"
      class="image-backdrop"
      aria-label="Close image preview"
      (click)="closeImage()"></button>
    <section class="image-modal" role="dialog" aria-modal="true" [attr.aria-label]="image.caption">
      <button
        type="button"
        class="image-close"
        aria-label="Close image preview"
        (click)="closeImage()">
        X
      </button>
      <img [src]="image.src" [alt]="image.caption" />
      <p>{{ image.caption }}</p>
      <button
        type="button"
        class="image-close-text"
        (click)="closeImage()">
        Close
      </button>
    </section>
  }

  <button
    type="button"
    class="launcher"
    (click)="openPanel()"
    [attr.aria-label]="isOpen() ? 'Help assistant is open' : 'Open help assistant'"
    [attr.aria-expanded]="isOpen()">
    ?
  </button>
</div>
